import "./utils/promisePolyfills";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./custom.css";
import "./designSystem/colorStyles";
import AuthProvider from "./AuthProvider";
import { Response } from "./pages/Response/Response";
import Layout from "./components/Layout";
import { ContextProvider } from "./components/Context/Context";
import RouteRuler from "./components/RouteRuler";
import { installMobileFontScaleBridge } from "./designSystem/mobileFontScale";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/reactQuery";
import { MGToastContainer } from "./designSystem/components/MGToast";

const removeMobileFontScaleBridge = installMobileFontScaleBridge();
if (module.hot) module.hot.dispose(removeMobileFontScaleBridge);

const rootElement = document.getElementById("root");

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <MGToastContainer />
    <BrowserRouter>
      <Switch>
        <Route path="/response/:code" component={Response} />
        <AuthProvider>
          <ContextProvider>
            <Layout>
              <RouteRuler />
            </Layout>
          </ContextProvider>
        </AuthProvider>
      </Switch>
    </BrowserRouter>
  </QueryClientProvider>,
  rootElement,
);
